import {
  type FormikErrors,
  type FormikProps,
  type FormikTouched,
} from "formik";
import { useTranslations } from "use-intl";

export function getFormikErrorsRecursive<T>(
  formikErrors: FormikErrors<T>,
  formikTouched?: FormikTouched<T>,
  t?: ReturnType<typeof useTranslations>,
) {
  const errors: string[] = [];
  (Object.keys(formikErrors) as (keyof T)[]).forEach((key) => {
    const value = formikErrors[key];
    const touched =
      formikTouched && formikTouched[key] ? formikTouched[key] : undefined;
    if (typeof value === "object") {
      errors.push(...getFormikErrorsRecursive(value, touched, t));
    } else if (value && touched) {
      errors.push(t ? t(value) : value);
    }
  });
  return errors;
}

export function getFieldError<T>(formik: FormikProps<T>, field: string) {
  const meta = formik.getFieldMeta(field);
  const touched = meta.touched;
  const error = meta.error;
  const triedSubmitting = formik.submitCount > 0;

  return (triedSubmitting || touched) && !!error ? error : undefined;
}
